export default __webpack_public_path__ + "static/media/Laboratory 03.fa28aea2.jpg";